import React from 'react';
import { Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../hooks/usePermissions';

export default function PermissionGate({
  scope,
  scopes,
  requireAll = false,
  fallback = null,
  showError = false,
  children
}) {
  const { t } = useTranslation('auth');
  const permissions = usePermissions();
  
  let hasPermission = false;
  
  if (scope) {
    hasPermission = permissions.hasScope(scope);
  } else if (scopes && scopes.length > 0) {
    hasPermission = requireAll
      ? permissions.hasAllScopes(scopes)
      : permissions.hasAnyScope(scopes);
  }
  
  if (!hasPermission) {
    if (showError) {
      return (
        <Alert severity="warning" sx={{ mt: 2 }}>
          {t('auth:permissions.access_denied')}
        </Alert>
      );
    }
    return fallback;
  }
  
  return children;
}